const ACTIVE_PAID_STATUSES = new Set(['active', 'trialing']);

const epochToDate = (value) => {
  if (!value) return null;
  const numeric = Number(value);
  if (Number.isFinite(numeric) && numeric > 0) return new Date(numeric * 1000);
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const userIsAdmin = (user) =>
  (user?.signInUserSession?.idToken?.payload?.['cognito:groups'] || []).includes('Admin');

export const evaluateMemberAccess = ({ user, grant, store = null, loading = false }) => {
  const now = new Date();
  const paidStatus = String(user?.attributes?.['custom:subscriptionStaus'] || 'inactive').toLowerCase();
  const paidUntil = epochToDate(user?.attributes?.['custom:billingPendDate']);
  // Stripe keeps a cancel-at-period-end subscription active until the paid
  // period actually finishes. The deletion webhook then changes this status
  // to canceled. This also avoids locking out legacy users whose old period
  // timestamp was incorrect.
  const paidActive = ACTIVE_PAID_STATUSES.has(paidStatus)
    || (paidStatus === 'past_due' && Boolean(paidUntil && paidUntil > now));
  const grantStarts = grant?.startsAt ? new Date(grant.startsAt) : null;
  const grantExpires = grant?.expiresAt ? new Date(grant.expiresAt) : null;
  const complimentaryActive = grant?.status === 'ACTIVE'
    && (!grantStarts || grantStarts <= now)
    && (!grantExpires || grantExpires > now);
  const admin = userIsAdmin(user);
  const storeActive = Boolean(user?.attributes?.sub && store?.active && store.source === 'app_store' && Date.parse(store.expiresAt) > now.getTime());
  const source = admin ? 'admin' : paidActive ? 'paid' : complimentaryActive ? 'complimentary' : storeActive ? 'app_store' : 'none';

  return {
    loading,
    hasPremiumAccess: source !== 'none',
    source,
    admin,
    paidStatus,
    paidUntil,
    paidActive,
    storeActive,
    storeUntil: storeActive ? new Date(store.expiresAt) : null,
    complimentaryActive,
    complimentaryUntil: grantExpires,
    grant,
  };
};
